import React from 'react';

/**
 * Consistent page header: title + optional subtitle + optional actions slot.
 * Layout-only — replaces the ad-hoc per-page `h2 + p` blocks. Styling lives in
 * styles/layout/layout-system.css (.page-header*).
 */
const PageHeader = ({ title, subtitle, actions, className = '' }) => (
  <header className={`page-header ${className}`}>
    <div className="page-header__titles">
      <h1 className="page-header__title">{title}</h1>
      {subtitle && <p className="page-header__subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="page-header__actions">{actions}</div>}
  </header>
);

export default PageHeader;
